import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'la-panel-footer',
  styleUrls: ['./panel-footer.component.scss'],
  templateUrl: './panel-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class PanelFooterComponent {}
